import React from 'react'
import ".//contentwrapper.scss"

export default function Contentwrapper({children}) {
  return (
    <div className='contentwrapper'>{children}</div>
  )
}
